/**
 * English locale — minimal because keys ARE English.
 *
 * i18next returns the key itself when no translation is found, so English
 * needs only non-obvious overrides (e.g. locale metadata for Day.js).
 *
 * All other translations (sv, de, fr …) live in their own files and
 * contain full key→translation maps.
 */

export const en = {
  locale: "en",
}
